export const NAME = 'sidebar';
export const LEVEL_ONE = 'SidebarComponentReducer';
